import Button from './Button';

export { Button };
